(function () {
  class YKSaleLimit {
    constructor(options = {}) {
      this.debounceMs = Number(options.debounceMs || 150);

      this._timer = null;
      this._busy = false;
      this._started = false;

      this._handleCartChange = this.scheduleCheck.bind(this);
    }

    getItems() {
      return Array.isArray(window.Rebuy?.SmartCart?.cart?.items) ? window.Rebuy.SmartCart.cart.items : [];
    }

    start() {
      if (this._started) return;

      this._started = true;
      document.addEventListener('rebuy:cart.change', this._handleCartChange);
      this.scheduleCheck();
    }

    stop() {
      if (!this._started) return;

      this._started = false;
      document.removeEventListener('rebuy:cart.change', this._handleCartChange);

      if (this._timer) {
        clearTimeout(this._timer);
        this._timer = null;
      }
    }

    scheduleCheck() {
      if (this._timer) clearTimeout(this._timer);

      this._timer = setTimeout(() => {
        this.enforce().catch((error) => {
          console.error('[YKSaleLimit] enforce failed', error);
        });
      }, this.debounceMs);
    }

    getItemProductId(item) {
      return Number(item?.product_id ?? item?.product?.id ?? 0);
    }

    getItemLineKey(item) {
      return String(item?.key ?? item?.id ?? '');
    }

    getItemQuantity(item) {
      return Number(item?.quantity || 0);
    }

    getItemSaleLimit(item) {
      const rawLimit = item?.product?.metafields?.custom?.settings_sale_limit;
      const limit = Number(rawLimit);

      if (!Number.isFinite(limit) || limit < 0) return null;
      return limit;
    }

    collectOverflowUpdates(items = this.getItems()) {
      const groupedItems = new Map();

      items.forEach((item, index) => {
        const productId = this.getItemProductId(item);
        const lineKey = this.getItemLineKey(item);
        const limit = this.getItemSaleLimit(item);
        const quantity = this.getItemQuantity(item);

        if (!productId || !lineKey || limit === null) return;

        if (!groupedItems.has(productId)) {
          groupedItems.set(productId, {
            limit,
            lines: [],
          });
        }

        const group = groupedItems.get(productId);
        group.limit = limit;
        group.lines.push({ item, index, quantity, lineKey });
      });

      const updates = [];

      groupedItems.forEach((group) => {
        let remainingAllowedQuantity = group.limit;

        group.lines
          .sort((a, b) => a.index - b.index)
          .forEach(({ item, quantity, lineKey }) => {
            const nextQuantity = Math.max(0, Math.min(quantity, remainingAllowedQuantity));

            if (nextQuantity !== quantity) {
              updates.push({
                item,
                lineKey,
                quantity: nextQuantity,
                previousQuantity: quantity,
                limit: group.limit,
              });
            }

            remainingAllowedQuantity = Math.max(0, remainingAllowedQuantity - nextQuantity);
          });
      });

      return updates;
    }

    changeItemQuantity(item, quantity) {
      const lineKey = this.getItemLineKey(item);
      if (!lineKey) return Promise.resolve(null);

      return new Promise((resolve, reject) => {
        window.Rebuy?.Cart?.changeItem(
          {
            id: lineKey,
            quantity,
          },
          {
            success: resolve,
            error: reject,
          }
        );
      });
    }

    async enforce() {
      if (this._busy) return;
      if (!window.Rebuy?.SmartCart?.cart?.items || !window.Rebuy?.Cart?.changeItem) return;

      const updates = this.collectOverflowUpdates();
      if (updates.length === 0) return;

      this._busy = true;

      try {
        for (const update of updates) {
          await this.changeItemQuantity(update.item, update.quantity);
        }
      } finally {
        this._busy = false;
      }
    }
  }

  const initSaleLimit = () => {
    if (window.ykSaleLimit instanceof YKSaleLimit) {
      window['yk-sale-limit-instance'] = window.ykSaleLimit;
      window.ykSaleLimit.start();
      return;
    }

    window.ykSaleLimit = new YKSaleLimit();
    window['yk-sale-limit-instance'] = window.ykSaleLimit;
    window.ykSaleLimit.start();
  };

  window.YKSaleLimit = YKSaleLimit;
  window['yk-sale-limit'] = YKSaleLimit;

  document.addEventListener('rebuy:smartcart.ready', initSaleLimit);

  if (window.Rebuy?.SmartCart?.cart) {
    initSaleLimit();
  }
})();
